import { gateway } from "../../../gateway";
import { IEventDeliverySigningSecretResponse } from "../interfaces";

export const getEventDeliverySigningSecret = async (): Promise<IEventDeliverySigningSecretResponse> => {
  const response = await gateway.get("/event-delivery/config/signing-secret");
  return response?.data?.data;
};
